<template>
  <div class="super_container">
    <link rel="stylesheet" type="text/css" href="styles/about_styles.css" />
    <link rel="stylesheet" type="text/css" href="styles/about_responsive.css" />
    <!-- Home -->

    <div class="home">
      <!-- Image by https://unsplash.com/@peecho -->
      <div
        class="home_background parallax-window"
        data-parallax="scroll"
        style="background-image: url(images/about_background.jpg)"
        data-speed="0.8"
      ></div>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="home_content">
              <div class="home_content_inner">
                <div class="home_title">O nas</div>
                <div class="home_breadcrumbs">
                  <ul class="home_breadcrumbs_list">
                    <li class="home_breadcrumb"><a href="index.html">Marena</a></li>
                    <li class="home_breadcrumb">O nas</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Find Form -->

    <TripContact />

    <!-- About -->

    <div class="about">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="section_title text-center">
              <h2>Pomagamy w wyborze podróży marzeń</h2>
              <div>Biuro podróży Marena</div>
            </div>
          </div>
        </div>
        <div class="row about_row">
          <div class="about_col">
            <div class="about_content">
              <p>
                Kierując się dewizą, że każdą pracę należy wykonywać z ogromną starannością i
                zapałem nasi pracownicy od kilkunastu lat starają się sprostać oczekiwaniom naszych
                klientów. Oferują pełen zakres usług turystycznych i produktów z nimi związanych.
              </p>
              <h5>Zajmujemy się:</h5>
              <li>
                Organizacją autorskich wycieczek po Polsce i Europie, które pozwalają nam na
                bezpośredni kontakt z klientem i nadają ton naszej działaności
              </li>
              <li>
                Sprzedażą biletów lotniczych wszystkich tanich i regularnych linii takich jak: LOT,
                British Airlines, Lufthasna, SAS, KLM, Finair Airlines, Austrian Arilines, Air
                Berlin, Aerlingus, Wizzair, Rayanair, Easy Jet
              </li>
              <li>Sprzedażą międzynarodowych biletów autokarowych</li>
              <li>Sprzedażą międzynarodowych biletów autokarowych</li>
              <li>Rezerwacją hoteli na całym świecie</li>
              <li>Sprzedażą ubezpieczeń turystycznych</li>
              <li>Sprzedażą kart ubezpieczeniowych (Euro26, Planeta Młodych)</li>
              <li>Sprzedażą wycieczek krajowych i zagranicznych indywidualnych jak i grupowych</li>
              <li>Sprzedażą wczasów lotniczych, autokarowych i z dojazdem własnym</li>
              <li>Sprzedażą kolonii, obozów młodzieżowych i językowych w kraju oraz zagranicą</li>
              <br />
              <h5>Współpracujemy m.in. z :</h5>
              <p>
                ITAKA, RAINBOW, EXIM TOURS, WEZYR HOLIDAYS, NET HOLIDA, GRECOS, NECKERMANN, ALMATUR
                i wiele innych.
              </p>
              <p>
                Nasz wysoko wyspecjalizowany personel dobierze do Państwa potrzeb idealną ofertę,
                gwarantując radość z poznawanych miejsc oraz energię z dobrze spędzonego czasu. Dla
                tych Państwa, którzy chcą wcześniej zaplanować urlop znajdziemy najlepsze ceny FIRST
                MINUTE, natomiast dla &quot;łowców okazji&quot; proponujemy atrakcyjne oferty LAST
                MINUTE.
              </p>
              <p>Nasze ceny są cenami ostatecznymi - nie zawierają ukrytych dopłat.</p>
              <p>
                Ponadto oferujemy bilety lotnicze: low-cost i regular, bilety autokarowe, promów,
                ubezpieczenia turystyczne.
              </p>
              <p>SERDECZNIE ZAPRASZAMY!</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Services -->

    <div class="services">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="section_title text-center">
              <h2>Nasze popularne usługi</h2>
            </div>
          </div>
        </div>
        <div class="row icon_box_container">
          <!-- Icon Box -->
          <div class="col-lg-4 icon_box_col">
            <div class="icon_box">
              <div class="icon_box_image">
                <img
                  src="images/service_1.svg"
                  class="svg"
                  alt="https://www.flaticon.com/authors/monkik"
                />
              </div>
              <div class="icon_box_title">Autorskie wycieczki</div>
              <p class="icon_box_text">
                Organizacją autorskich wycieczek po Polsce i Europie, które pozwalają nam na
                bezpośredni kontakt z klientem i nadają ton naszej działaności. Nasze biuro od paru
                lat jako cel objęło pokazanie nam – Polakom – piękna jakie oferuje nasz kraj.
                Dlatego też co roku organizujemy kilkanaście autorskich wycieczek głownie po naszych
                ojczystych terenach.
              </p>
              <!-- <a href="#" class="icon_box_more">
							Czytaj dalej
						</a> -->
            </div>
          </div>

          <!-- Icon Box -->
          <div class="col-lg-4 icon_box_col">
            <div class="icon_box">
              <div class="icon_box_image">
                <img
                  src="images/service_2.svg"
                  class="svg"
                  alt="https://www.flaticon.com/authors/monkik"
                />
              </div>
              <div class="icon_box_title">Bilety autokarowe i lotnicze</div>
              <p class="icon_box_text">
                Współpracujemy z wieloma uznanymi przewoźnikami autokarowymi a szczególnie z jedną z
                największych firm przewozowych w Europie, a w Polsce zdecydowanym liderem - firmą
                Sinbad. Ponadto można w naszym biurze zakupić bilety firmy Trans Expres na trasy
                autokarowe obejmujące docelowo dojazd m.in . do Niemiec oraz wiele innych ofert.
              </p>
              <!-- <a href="#" class="icon_box_more">
							Czytaj dalej
						</a> -->
            </div>
          </div>

          <!-- Icon Box -->
          <div class="col-lg-4 icon_box_col">
            <div class="icon_box">
              <div class="icon_box_image">
                <img
                  src="images/service_3.svg"
                  class="svg"
                  alt="https://www.flaticon.com/authors/monkik"
                />
              </div>
              <div class="icon_box_title">Wczasy</div>
              <p class="icon_box_text">
                Zawsze chętnie służymy pomocą i radą w wyborze hotelu oraz miejsca wyjazdu na
                wymarzony urlop. Staramy sie dopasować ofertę do możliwości finansowych klientów,
                nie narażając ich na brak komfortu. Będziemy sie nadal starać, aby zapewnić naszym
                dotychczasowym jak i nowym klientom profesjonalną obsługę, a wyjazdy oferowanie
                przez nasze Biuro dostarczą Państwu niezapomnianych wspomnień z wypoczynku.
              </p>
              <!-- <a href="#" class="icon_box_more">
							Czytaj dalej
						</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TripContact from '@/components/TripContact.vue'
import Subscribe from '@/components/Subscribe.vue'

export default {
  name: 'About',
  components: {
    TripContact,
    Subscribe,
  },
}
</script>

<style scoped lang="scss">
.icon_box_title {
  font-size: 20px;
}
.button {
  background: #ef7e1a;
}
.about {
  padding-bottom: 0;
}
.about_content {
  color: #7d8293;
  font-weight: 300;
  line-height: 2;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
}
</style>
